import { render, staticRenderFns } from "./AnomalyScatterPlot.vue?vue&type=template&id=24324221&scoped=true&"
import script from "./AnomalyScatterPlot.vue?vue&type=script&lang=js&"
export * from "./AnomalyScatterPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24324221",
  null
  
)

export default component.exports